// services/UserService.js
import axios from "axios";
import {getConfig} from "../configService";

export class UserService {
    static keycloak = null;

    static getUserServiceBaseUrl(){
      if((window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && getConfig().localhostApi) {
        return "http://localhost:5045/v1";
      }
      return getConfig().apiBaseUrl + "/users/v1";
    }

    static async getUserProfile() {
      try {
        const userServiceBaseUrl = UserService.getUserServiceBaseUrl();

        if(!UserService.keycloak.authenticated) return;
        
        const userId = UserService.keycloak.tokenParsed.sub;

        return await axios({
          method: "get",
          url: `${userServiceBaseUrl}/User/${userId}`,
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + UserService.keycloak.token
          },
        });
      } catch (error) {
        console.error(error);
        throw error;
      }
    }

    static async updateUserProfile(userData) {
      try {
        const userServiceBaseUrl = UserService.getUserServiceBaseUrl();
        if(!UserService.keycloak.authenticated) return;
        const userId = UserService.keycloak.tokenParsed.sub;

        return await axios({
          method: "post",
          url: `${userServiceBaseUrl}/User/${userId}`,
          data: userData,
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + UserService.keycloak.token
          },
        });
      } catch (error) {
        console.error(error);
        return error.response;
      }
    }

    static async generateProfilePictureUploadURL() {
      try {
        const userServiceBaseUrl = UserService.getUserServiceBaseUrl();

        if(!UserService.keycloak.authenticated) return;
        const userId = UserService.keycloak.tokenParsed.sub;

        return await axios({
          method: "post",
          url: `${userServiceBaseUrl}/PhotoUploader/${userId}`,
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + UserService.keycloak.token
          },
        });
      } catch (error) {
        console.error(error);
        return error.response;
      }
    }

    static async uploadProfilePicture(uploadURL, image) {
      try {
        return await axios({
          method: "put",
          url: uploadURL,
          data: image,
          headers: {
            "Content-Type": image.type,
            "x-ms-blob-type": "BlockBlob",
          },
        });
      } catch (error) {
        console.error(error);
        return error.response;
      }
    }

    static async completeProfilePictureUpload(imageId) {
      try {
        const userServiceBaseUrl = UserService.getUserServiceBaseUrl();

        if(!UserService.keycloak.authenticated) return;
        const userId = UserService.keycloak.tokenParsed.sub;

        return await axios({
          method: "put",
          url: `${userServiceBaseUrl}/PhotoUploader/${userId}/${imageId}/status`,
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + UserService.keycloak.token
          },
          data: {"status":"Completed"}
        });
      } catch (error) {
        console.error(error);
        return error.response;
      }
    }

    static async acceptTos(tosVersion) {
      const userServiceBaseUrl = UserService.getUserServiceBaseUrl();
      if(!UserService.keycloak.authenticated) return;
      const userId = UserService.keycloak.tokenParsed.sub;

      return await axios({
        method: "put",
        url: `${userServiceBaseUrl}/User/${userId}/tos-consent`,
        data: { tosVersion },
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + UserService.keycloak.token
        },
      });
    }
} 